import React, { useEffect } from 'react'

import { useWrapperContext } from 'components/Wrapper/Wrapper'
import { SelectDropdown, Separator } from 'shared/components'
import { useQuery } from 'shared/hooks'
import { sortOptionsType, transformSortOptions } from 'shared/pipes'
import { List } from './List'
import { PartnersForm } from 'components/Partners'
import classes from './NewsList.module.scss'

const sorByOptions: sortOptionsType[] = [
  sortOptionsType.New,
  sortOptionsType.Old,
  sortOptionsType.NameDesk,
  sortOptionsType.NameAsk,
]

export const NewsList = (): JSX.Element => {
  const { setHeaderWhite } = useWrapperContext()
  const [query, setQuery] = useQuery()
  const defaultValue = sorByOptions[0]

  useEffect(() => {
    setHeaderWhite(true)
    return () => setHeaderWhite(false)
  })

  const renderOption = (v: string) => transformSortOptions(v)

  return (
    <div className="container offset-header">
      <h1 className={`title ${classes.title}`}>НОВОСТИ</h1>
      <SelectDropdown
        options={sorByOptions}
        value={query?.sortBy || defaultValue}
        onClick={v => setQuery({ ...query, sortBy: v })}
        renderOption={renderOption}
      />
      <List />
      <PartnersForm />
      <Separator height={24} />
    </div>
  )
}
